<div class="weaveFormField"
  [ngClass]="{'error': showError && initialData.length === 0 && required}"
  >

  <div class="weaveCheckboxGroup">
    <label>{{label}} @if (label && required) {
      <span class="required">*</span>
    }</label>

    @for (checkbox of checkboxListState; track checkbox; let i = $index) {
      <div>
        <app-weave-checkbox
          [data]="checkbox.data"
          [value]="checkbox.value"
          [label]="checkbox.label"
          [classList]="'simpleCheckbox'"
          (changed)="onChange($event)"
        ></app-weave-checkbox>
      </div>
    }
  </div>
  @if (showError && initialData.length === 0 && required) {
    <div
      class="weaveFormField_error">
      {{message}} cannot be empty
    </div>
  }
</div>
